import { Activity, ArrowLeftRight, Ban, CloudRain, HeartPulse, UserCog, TrendingUp, Users, AlertTriangle, CalendarX, XOctagon } from "lucide-react";

export const LEAGUE_COLORS = {
  NFL: "#38BDF8",
  NBA: "#FF8C00",
  NHL: "#A855F7",
  MLB: "#00E5A3",
};

const STATUS = {
  active: { label: "Active", color: "#00E5A3", bg: "rgba(0,229,163,0.12)" },
  questionable: { label: "Questionable", color: "#FFB020", bg: "rgba(255,176,32,0.12)" },
  doubtful: { label: "Doubtful", color: "#FF8C00", bg: "rgba(255,140,0,0.12)" },
  out: { label: "Out", color: "#FF4D4D", bg: "rgba(255,77,77,0.12)" },
};

export function StatusBadge({ status, className = "" }) {
  const s = STATUS[status] || STATUS.active;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-semibold font-mono uppercase tracking-wide ${className}`}
      style={{ color: s.color, background: s.bg, border: `1px solid ${s.color}33` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.color }} />
      {s.label}
    </span>
  );
}

export function SourceBadge({ official, source }) {
  return (
    <span
      data-testid={`source-badge-${official ? "official" : "reported"}`}
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-semibold font-mono uppercase tracking-wider"
      style={
        official
          ? { color: "#38BDF8", background: "rgba(56,189,248,0.1)", border: "1px solid #38BDF833" }
          : { color: "#A855F7", background: "rgba(168,85,247,0.1)", border: "1px solid #A855F733" }
      }
    >
      {official ? "OFFICIAL" : "REPORTED"}
      <span className="text-slate-400 normal-case font-normal tracking-normal">· {source}</span>
    </span>
  );
}

export function LeagueChip({ league }) {
  const c = LEAGUE_COLORS[league] || "#94A3B8";
  return (
    <span
      data-testid={`league-chip-${league}`}
      className="rounded px-1.5 py-0.5 text-[11px] font-bold font-mono tracking-wider"
      style={{ color: c, background: `${c}18`, border: `1px solid ${c}33` }}
    >
      {league}
    </span>
  );
}

export const CATEGORY_META = {
  injury: { label: "Injury", icon: HeartPulse, color: "#FF4D4D" },
  practice_absence: { label: "Practice Absence", icon: CalendarX, color: "#FFB020" },
  conditioning_concern: { label: "Availability Risk", icon: AlertTriangle, color: "#FF8C00" },
  late_scratch: { label: "Late Scratch", icon: XOctagon, color: "#FF4D4D" },
  return_from_injury: { label: "Return", icon: Activity, color: "#00E5A3" },
  trade: { label: "Trade", icon: ArrowLeftRight, color: "#38BDF8" },
  suspension: { label: "Suspension", icon: Ban, color: "#FF8C00" },
  personal: { label: "Personal", icon: Users, color: "#A855F7" },
  coach_decision: { label: "Coach's Decision", icon: UserCog, color: "#FFB020" },
  weather: { label: "Weather", icon: CloudRain, color: "#38BDF8" },
  lineup_change: { label: "Market Move", icon: TrendingUp, color: "#94A3B8" },
};

export function CategoryTag({ category }) {
  const m = CATEGORY_META[category] || CATEGORY_META.lineup_change;
  const Icon = m.icon;
  return (
    <span
      data-testid={`category-tag-${category}`}
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-semibold font-mono uppercase tracking-wide"
      style={{ color: m.color, background: `${m.color}14`, border: `1px solid ${m.color}30` }}
    >
      <Icon size={12} />
      {m.label}
    </span>
  );
}
